const TRANSACTION_HISTORY_SOURCE_ENUM = {
    //внутренний перевод типа с адреса на авансовый баланс
    INTERNAL_TRANSACTION: 'internal',

    //внешняя отправка/прием
    EXTERNAL: 'external',
};

export default TRANSACTION_HISTORY_SOURCE_ENUM;